import axios from "axios";

export const state = {
  loading: false,
  data: {},
  status: {},
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_DATA(state, data) {
    state.data = (data || []).reduce((r, e) => (r[e.id] = e, r), {})
  },
  SET_STATUS(state, status) {
    state.status = status
  },
}

export const getters = {}

export const actions = {
  fetch({commit}) {
    commit('SET_LOADING', true)
    axios
      .get(`/entities/api/v1/users`)
      .then(({data: {Body}}) => commit('SET_DATA', Body))
      .finally(() => commit('SET_LOADING', false))
  },
  async ping({commit}) {
    await axios.put(`/chats/api/v1/user/status`, {status: 1})
    await axios.get(`/chats/api/v1/user/status`).then(({data: {status}}) => commit('SET_STATUS', status))
  },
}

